import { Test } from '../types/tests';

// Beck Depression Inventory II (BDI-II) - Professional depression screening test
export const testsData: Test[] = [
    {
        id: 'hads-anxiety-depression',
        title: 'Госпитальная шкала тревоги и депрессии (HADS)',
        description: 'Скрининговая шкала для выявления и оценки тяжести симптомов депрессии и тревоги',
        fullDescription: 'Госпитальная шкала тревоги и депрессии (Hospital Anxiety and Depression Scale, HADS) была разработана в 1983 году двумя авторами (Zigmond A.S. и Snaith R.P.) с целью определения и оценки тяжести симптомов депрессии и тревоги в условиях общемедицинской практики. Преимущества шкалы HADS заключаются в простоте применения и обработки, что позволяет рекомендовать ее к использованию для первичного выявления (скрининга) тревоги и депрессии.',
        instruction: 'Вам предлагается заполнить опросник HADS — он помогает оценить уровень тревоги и депрессивных переживаний за последние 7 дней.\n\nПожалуйста, отвечайте честно, опираясь на свои реальные ощущения. В тесте нет правильных или неправильных ответов. Выбирайте тот вариант, который лучше всего описывает ваше состояние в последнее время, не задерживаясь долго на каждом вопросе.',
        duration: '2-5 минут',
        imageUrl: '/images/character-hads.svg',
        questions: [
            // Часть I (оценка уровня ТРЕВОГИ)
            {
                id: 'q1',
                subscale: 'anxiety',
                text: '1. Я испытываю напряжение, мне не по себе',
                answers: [
                    { id: 'a3', text: 'Все время', score: 3 },
                    { id: 'a2', text: 'Часто', score: 2 },
                    { id: 'a1', text: 'Время от времени, иногда', score: 1 },
                    { id: 'a0', text: 'Совсем не испытываю', score: 0 },
                ],
            },
            {
                id: 'q2',
                subscale: 'anxiety',
                text: '2. Я испытываю страх, кажется, что что-то ужасное может вот-вот случиться',
                answers: [
                    { id: 'a3', text: 'Определенно это так, и страх очень велик', score: 3 },
                    { id: 'a2', text: 'Да, это так, но страх не очень велик', score: 2 },
                    { id: 'a1', text: 'Иногда, но это меня не беспокоит', score: 1 },
                    { id: 'a0', text: 'Совсем не испытываю', score: 0 },
                ],
            },
            {
                id: 'q3',
                subscale: 'anxiety',
                text: '3. Беспокойные мысли крутятся у меня в голове',
                answers: [
                    { id: 'a3', text: 'Постоянно', score: 3 },
                    { id: 'a2', text: 'Большую часть времени', score: 2 },
                    { id: 'a1', text: 'Время от времени и не так часто', score: 1 },
                    { id: 'a0', text: 'Только иногда', score: 0 },
                ],
            },
            {
                id: 'q4',
                subscale: 'anxiety',
                text: '4. Я легко могу присесть и расслабиться',
                answers: [
                    { id: 'a0', text: 'Определенно, это так', score: 0 },
                    { id: 'a1', text: 'Наверно, это так', score: 1 },
                    { id: 'a2', text: 'Лишь изредка, это так', score: 2 },
                    { id: 'a3', text: 'Совсем не могу', score: 3 },
                ],
            },
            {
                id: 'q5',
                subscale: 'anxiety',
                text: '5. Я испытываю внутреннее напряжение или дрожь',
                answers: [
                    { id: 'a0', text: 'Совсем не испытываю', score: 0 },
                    { id: 'a1', text: 'Иногда', score: 1 },
                    { id: 'a2', text: 'Часто', score: 2 },
                    { id: 'a3', text: 'Очень часто', score: 3 },
                ],
            },
            {
                id: 'q6',
                subscale: 'anxiety',
                text: '6. Я испытываю неусидчивость, мне постоянно нужно двигаться',
                answers: [
                    { id: 'a3', text: 'Определенно, это так', score: 3 },
                    { id: 'a2', text: 'Наверно, это так', score: 2 },
                    { id: 'a1', text: 'Лишь в некоторой степени, это так', score: 1 },
                    { id: 'a0', text: 'Совсем не испытываю', score: 0 },
                ],
            },
            {
                id: 'q7',
                subscale: 'anxiety',
                text: '7. У меня бывает внезапное чувство паники',
                answers: [
                    { id: 'a3', text: 'Очень часто', score: 3 },
                    { id: 'a2', text: 'Довольно часто', score: 2 },
                    { id: 'a1', text: 'Не так уж часто', score: 1 },
                    { id: 'a0', text: 'Совсем не бывает', score: 0 },
                ],
            },
            // Часть II (оценка уровня ДЕПРЕССИИ)
            {
                id: 'q8',
                subscale: 'depression',
                text: '8. То, что приносило мне большое удовольствие, и сейчас вызывает у меня такое же чувство',
                answers: [
                    { id: 'a0', text: 'Определенно, это так', score: 0 },
                    { id: 'a1', text: 'Наверное, это так', score: 1 },
                    { id: 'a2', text: 'Лишь в очень малой степени, это так', score: 2 },
                    { id: 'a3', text: 'Это совсем не так', score: 3 },
                ],
            },
            {
                id: 'q9',
                subscale: 'depression',
                text: '9. Я способен рассмеяться и увидеть в том или ином событии смешное',
                answers: [
                    { id: 'a0', text: 'Определенно, это так', score: 0 },
                    { id: 'a1', text: 'Наверное, это так', score: 1 },
                    { id: 'a2', text: 'Лишь в очень малой степени, это так', score: 2 },
                    { id: 'a3', text: 'Совсем не способен', score: 3 },
                ],
            },
            {
                id: 'q10',
                subscale: 'depression',
                text: '10. Я испытываю бодрость',
                answers: [
                    { id: 'a3', text: 'Совсем не испытываю', score: 3 },
                    { id: 'a2', text: 'Очень редко', score: 2 },
                    { id: 'a1', text: 'Иногда', score: 1 },
                    { id: 'a0', text: 'Практически все время', score: 0 },
                ],
            },
            {
                id: 'q11',
                subscale: 'depression',
                text: '11. Мне кажется, что я стал все делать очень медленно',
                answers: [
                    { id: 'a3', text: 'Практически все время', score: 3 },
                    { id: 'a2', text: 'Часто', score: 2 },
                    { id: 'a1', text: 'Иногда', score: 1 },
                    { id: 'a0', text: 'Совсем нет', score: 0 },
                ],
            },
            {
                id: 'q12',
                subscale: 'depression',
                text: '12. Я не слежу за своей внешностью',
                answers: [
                    { id: 'a3', text: 'Определенно, это так', score: 3 },
                    { id: 'a2', text: 'Я не уделяю этому столько времени, сколько нужно', score: 2 },
                    { id: 'a1', text: 'Может быть, я стал меньше уделять этому времени', score: 1 },
                    { id: 'a0', text: 'Я слежу за собой так же, как и раньше', score: 0 },
                ],
            },
            {
                id: 'q13',
                subscale: 'depression',
                text: '13. Я считаю, что мои дела (занятия, увлечения) могут принести мне чувство удовлетворения',
                answers: [
                    { id: 'a0', text: 'Точно так же, как и обычно', score: 0 },
                    { id: 'a1', text: 'Да, но не в той степени, как раньше', score: 1 },
                    { id: 'a2', text: 'Значительно меньше, чем обычно', score: 2 },
                    { id: 'a3', text: 'Совсем так не считаю', score: 3 },
                ],
            },
            {
                id: 'q14',
                subscale: 'depression',
                text: '14. Я могу получить удовольствие от хорошей книги, радио- или телепрограммы',
                answers: [
                    { id: 'a0', text: 'Часто', score: 0 },
                    { id: 'a1', text: 'Иногда', score: 1 },
                    { id: 'a2', text: 'Редко', score: 2 },
                    { id: 'a3', text: 'Очень редко', score: 3 },
                ],
            },
        ],
        subscales: [
            {
                id: 'anxiety',
                title: 'Шкала Тревоги',
                interpretations: [
                    {
                        minScore: 0,
                        maxScore: 7,
                        category: 'Норма',
                        description: 'Отсутствие достоверно выраженных симптомов тревоги',
                        longDescription: 'Ваш уровень тревоги находится в пределах нормы.'
                    },
                    {
                        minScore: 8,
                        maxScore: 10,
                        category: 'Субклиническая тревога',
                        description: 'Субклинически выраженная тревога',
                        longDescription: 'У вас наблюдаются признаки повышенной тревожности. Рекомендуется обратить внимание на свое состояние.'
                    },
                    {
                        minScore: 11,
                        maxScore: 21,
                        category: 'Клиническая тревога',
                        description: 'Клинически выраженная тревога',
                        longDescription: 'У вас наблюдается высокий уровень тревоги. Настоятельно рекомендуется обратиться к специалисту.'
                    }
                ]
            },
            {
                id: 'depression',
                title: 'Шкала Депрессии',
                interpretations: [
                    {
                        minScore: 0,
                        maxScore: 7,
                        category: 'Норма',
                        description: 'Отсутствие достоверно выраженных симптомов депрессии',
                        longDescription: 'Ваш уровень депрессии находится в пределах нормы.'
                    },
                    {
                        minScore: 8,
                        maxScore: 10,
                        category: 'Субклиническая депрессия',
                        description: 'Субклинически выраженная депрессия',
                        longDescription: 'У вас наблюдаются признаки сниженного настроения. Рекомендуется обратить внимание на свое состояние.'
                    },
                    {
                        minScore: 11,
                        maxScore: 21,
                        category: 'Клиническая депрессия',
                        description: 'Клинически выраженная депрессия',
                        longDescription: 'У вас наблюдается выраженный уровень депрессии. Настоятельно рекомендуется обратиться к специалисту.'
                    }
                ]
            }
        ],
        interpretations: [] // Not used for the whole test, subscales are used instead
    },
    {
        id: 'beck-depression-inventory',
        title: 'Шкала депрессии Бека 2 (BDI-II)',
        description: 'Beck Depression Inventory II - стандартизированный опросник для оценки уровня депрессии',
        fullDescription: 'Тест-опросник депрессии (Опросник депрессии Бека) был предложен Аароном Т. Беком в 1961 году на основе клинических наблюдений, выявивших симптомы депрессии. В 1978 и 1996 годах появились последующие версии теста. В своей последней версии тест Шкала депреcсии Бека 2 (Beck Depression Inventory II, BDI-II) предназначен для взрослых и подростков с 13 лет. Это самый точный тест на депрессию по шкале Бека, он состоит из 21 вопроса для определения тяжести симптомов депрессии. По результатам теста вы сможете оценить у себя степень выраженности депрессивного синдрома.',
        instruction: 'Пожалуйста, внимательно прочитайте каждую группу утверждений.\nВ каждой группе выберите одно утверждение, которое наиболее точно отражает то, как вы чувствовали себя в течение последних двух недель, включая сегодняшний день.\n\nВажно отвечать исходя из вашего реального состояния, не пытаясь оценивать, «хорошо это или плохо».\nПравильных или неправильных ответов нет. Есть только то, что вы действительно ощущали.',
        duration: '4-7 минут',
        imageUrl: '/images/character-depression.svg',
        questions: [
            {
                id: 'q1',
                text: '1. Печаль',
                answers: [
                    { id: 'a1', text: 'Мне не грустно.', score: 0 },
                    { id: 'a2', text: 'Я чувствую печаль большую часть времени.', score: 1 },
                    { id: 'a3', text: 'Я все время печален.', score: 2 },
                    { id: 'a4', text: 'Я так печален и несчастлив, что я не могу этого вынести.', score: 3 },
                ],
            },
            {
                id: 'q2',
                text: '2. Пессимизм',
                answers: [
                    { id: 'a1', text: 'Я не тревожусь о своем будущем.', score: 0 },
                    { id: 'a2', text: 'Я тревожусь о будущем больше обычного.', score: 1 },
                    { id: 'a3', text: 'Я чувствую, что меня ничего не ждет в будущем.', score: 2 },
                    { id: 'a4', text: 'Мое будущее безнадежно и будет еще хуже', score: 3 },
                ],
            },
            {
                id: 'q3',
                text: '3. Ощущение несостоятельности',
                answers: [
                    { id: 'a1', text: 'Я не чувствую себя неудачником.', score: 0 },
                    { id: 'a2', text: 'Я потерпел больше неудач, чем следовало бы.', score: 1 },
                    { id: 'a3', text: 'Когда я оглядываюсь на свою жизнь, я вижу в ней много неудач.', score: 2 },
                    { id: 'a4', text: 'Я чувствую, что как личность я — полный неудачник.', score: 3 },
                ],
            },
            {
                id: 'q4',
                text: '4. Потеря удовольствия',
                answers: [
                    { id: 'a1', text: 'Я получаю так же много удовольствия от того, чем я всегда наслаждался.', score: 0 },
                    { id: 'a2', text: 'Я не получаю такого же удовольствия, как раньше.', score: 1 },
                    { id: 'a3', text: 'Я получаю совсем немного удовольствия от тех вещей, которыми привык наслаждаться.', score: 2 },
                    { id: 'a4', text: 'Я не получаю никакого удовольствия от того, чем обычно наслаждался.', score: 3 },
                ],
            },
            {
                id: 'q5',
                text: '5. Чувство вины',
                answers: [
                    { id: 'a1', text: 'Я не чувствую себя виноватым в чем-либо.', score: 0 },
                    { id: 'a2', text: 'Я чувствую себя виноватым за многое, что я сделал или должен был бы сделать.', score: 1 },
                    { id: 'a3', text: 'Я чувствую себя виноватым большую часть времени.', score: 2 },
                    { id: 'a4', text: 'Я чувствую себя виноватым все время.', score: 3 },
                ],
            },
            {
                id: 'q6',
                text: '6. Ощущение наказанности',
                answers: [
                    { id: 'a1', text: 'Я не чувствую, что могу быть наказанным за что-либо.', score: 0 },
                    { id: 'a2', text: 'Я чувствую, что могу быть наказан за что-либо.', score: 1 },
                    { id: 'a3', text: 'Я ожидаю, что буду наказан.', score: 2 },
                    { id: 'a4', text: 'Я чувствую себя уже наказанным.', score: 3 },
                ],
            },
            {
                id: 'q7',
                text: '7. Нелюбовь к себе',
                answers: [
                    { id: 'a1', text: 'Мое отношение к себе не изменилось.', score: 0 },
                    { id: 'a2', text: 'Я потерял уверенность в себе.', score: 1 },
                    { id: 'a3', text: 'Я разочарован в себе.', score: 2 },
                    { id: 'a4', text: 'Я не люблю себя.', score: 3 },
                ],
            },
            {
                id: 'q8',
                text: '8. Самокритичность',
                answers: [
                    { id: 'a1', text: 'Я критикую или обвиняю себя не больше, чем обычно.', score: 0 },
                    { id: 'a2', text: 'Я более критичен к себе, чем раньше.', score: 1 },
                    { id: 'a3', text: 'Я критикую себя за все свои ошибки.', score: 2 },
                    { id: 'a4', text: 'Я виню себя во всем плохом, что происходит.', score: 3 },
                ],
            },
            {
                id: 'q9',
                text: '9. Суицидальные мысли',
                answers: [
                    { id: 'a1', text: 'Я никогда не думал покончить с собой.', score: 0 },
                    { id: 'a2', text: 'У меня есть мысли о том, чтобы покончить с собой, но я этого не сделаю.', score: 1 },
                    { id: 'a3', text: 'Я хотел бы покончить с собой.', score: 2 },
                    { id: 'a4', text: 'Я бы убил себя, если бы представился случай', score: 3 },
                ],
            },
            {
                id: 'q10',
                text: '10. Слезливость',
                answers: [
                    { id: 'a1', text: 'Я плачу не больше, чем обычно.', score: 0 },
                    { id: 'a2', text: 'Я плачу больше, чем обычно.', score: 1 },
                    { id: 'a3', text: 'Я плачу по любому незначительному поводу.', score: 2 },
                    { id: 'a4', text: 'Мне хочется плакать, но уже не могу.', score: 3 },
                ],
            },
            {
                id: 'q11',
                text: '11. Возбуждение',
                answers: [
                    { id: 'a1', text: 'Я не более беспокоен или взволнован, чем обычно.', score: 0 },
                    { id: 'a2', text: 'Я чувствую себя более беспокойно или взволнованно, чем обычно.', score: 1 },
                    { id: 'a3', text: 'Я так взволнован и обеспокоен, что мне трудно оставаться на месте.', score: 2 },
                    { id: 'a4', text: 'Я так взволнован и взвинчен, что мне нужно двигаться или делать хоть что-нибудь.', score: 3 },
                ],
            },
            {
                id: 'q12',
                text: '12. Потеря интереса',
                answers: [
                    { id: 'a1', text: 'Я не утратил интереса к другим людям и делам.', score: 0 },
                    { id: 'a2', text: 'Я меньше интересуюсь другими людьми и делами.', score: 1 },
                    { id: 'a3', text: 'Я практически потерял интерес к другим людям и делам.', score: 2 },
                    { id: 'a4', text: 'Мне тяжело заинтересоваться чем-либо.', score: 3 },
                ],
            },
            {
                id: 'q13',
                text: '13. Нерешительность',
                answers: [
                    { id: 'a1', text: 'Я принимаю решения так же, как всегда.', score: 0 },
                    { id: 'a2', text: 'Принятие решений дается мне труднее, чем обычно.', score: 1 },
                    { id: 'a3', text: 'Мне гораздо труднее, чем раньше, дается принятие решений.', score: 2 },
                    { id: 'a4', text: 'У меня есть проблемы с принятием любых решений.', score: 3 },
                ],
            },
            {
                id: 'q14',
                text: '14. Бесполезность',
                answers: [
                    { id: 'a1', text: 'Я не чувствую себя бесполезным.', score: 0 },
                    { id: 'a2', text: 'Я не чувствую себя таким же стоящим и полезным, как раньше.', score: 1 },
                    { id: 'a3', text: 'Я чувствую себя менее полезным по сравнению с другими людьми.', score: 2 },
                    { id: 'a4', text: 'Я чувствую себя совершенно никчемным.', score: 3 },
                ],
            },
            {
                id: 'q15',
                text: '15. Обессиленность',
                answers: [
                    { id: 'a1', text: 'Я энергичен так же, как всегда.', score: 0 },
                    { id: 'a2', text: 'У меня меньше энергии, чем обычно.', score: 1 },
                    { id: 'a3', text: 'Мне не хватает сил на очень многое.', score: 2 },
                    { id: 'a4', text: 'У меня нет энергии вообще.', score: 3 },
                ],
            },
            {
                id: 'q16',
                text: '16. Изменения в режиме сна',
                answers: [
                    { id: 'a0', text: 'Я не испытал никаких изменений в режиме сна.', score: 0 },
                    { id: 'a1a', text: 'Я сплю немного больше обычного.', score: 1 },
                    { id: 'a1b', text: 'Я сплю немного меньше обычного', score: 1 },
                    { id: 'a2a', text: 'Я сплю намного больше, чем обычно.', score: 2 },
                    { id: 'a2b', text: 'Я сплю намного меньше, чем обычно.', score: 2 },
                    { id: 'a3a', text: 'Я сплю большую часть дня.', score: 3 },
                    { id: 'a3b', text: 'Я просыпаюсь через каждый час или два.', score: 3 },
                ],
            },
            {
                id: 'q17',
                text: '17. Раздражительность',
                answers: [
                    { id: 'a1', text: 'Я не более раздражителен, чем обычно.', score: 0 },
                    { id: 'a2', text: 'Я более раздражителен, чем обычно.', score: 1 },
                    { id: 'a3', text: 'Я гораздо более раздражителен, чем обычно.', score: 2 },
                    { id: 'a4', text: 'Я всегда раздражен.', score: 3 },
                ],
            },
            {
                id: 'q18',
                text: '18. Изменения в аппетите',
                answers: [
                    { id: 'a0', text: 'Мой аппетит не изменился.', score: 0 },
                    { id: 'a1a', text: 'Я ем немного меньше обычного.', score: 1 },
                    { id: 'a1b', text: 'Я ем немного больше обычного', score: 1 },
                    { id: 'a2a', text: 'Мой аппетит намного меньше, чем раньше.', score: 2 },
                    { id: 'a2b', text: 'Мой аппетит намного больше обычного.', score: 2 },
                    { id: 'a3a', text: 'У меня нет аппетита вообще.', score: 3 },
                    { id: 'a3b', text: 'Я все время хочу есть.', score: 3 },
                ],
            },
            {
                id: 'q19',
                text: '19. Концентрация внимания',
                answers: [
                    { id: 'a1', text: 'Я могу сосредоточиваться так же хорошо, как всегда.', score: 0 },
                    { id: 'a2', text: 'Я не могу сконцентрироваться так же хорошо, как обычно.', score: 1 },
                    { id: 'a3', text: 'Мне трудно сосредоточиться на чем-то надолго.', score: 2 },
                    { id: 'a4', text: 'Я считаю, что не могу сконцентрироваться ни на чем.', score: 3 },
                ],
            },
            {
                id: 'q20',
                text: '20. Усталость или утомление',
                answers: [
                    { id: 'a1', text: 'Я не более уставший или утомленный, чем обычно.', score: 0 },
                    { id: 'a2', text: 'Я устаю или утомляюсь легче, чем обычно.', score: 1 },
                    { id: 'a3', text: 'Я слишком устал и утомлен, чтобы делать многое из привычных для себя вещей.', score: 2 },
                    { id: 'a4', text: 'Я слишком устал и утомлен, чтобы делать большинство привычных дел.', score: 3 },
                ],
            },
            {
                id: 'q21',
                text: '21. Потеря сексуального влечения',
                answers: [
                    { id: 'a1', text: 'Я не заметил никаких изменений в своем интересе к сексу.', score: 0 },
                    { id: 'a2', text: 'Секс интересует меня меньше, чем раньше.', score: 1 },
                    { id: 'a3', text: 'Сейчас секс интересует меня гораздо меньше.', score: 2 },
                    { id: 'a4', text: 'Я полностью потерял интерес к сексу.', score: 3 },
                ],
            },
        ],
        interpretations: [
            {
                minScore: 0,
                maxScore: 13,
                category: 'Нормальное состояние',
                description: 'Уровень депрессии в пределах нормы',
                longDescription:
                    'Ваши результаты указывают на отсутствие клинически значимой депрессии. Вы находитесь в нормальном эмоциональном состоянии. Продолжайте заботиться о своем психическом здоровье и поддерживайте здоровый образ жизни.',
            },
            {
                minScore: 14,
                maxScore: 19,
                category: 'Симптомы легкой депрессии',
                description: 'Обнаружены симптомы легкой депрессии',
                longDescription:
                    'Ваш результат указывает на наличие легких депрессивных симптомов. Рекомендуется обратить внимание на свое эмоциональное состояние, увеличить физическую активность, наладить режим сна и обратиться к специалисту для консультации. Раннее обращение за помощью может предотвратить ухудшение состояния.',
            },
            {
                minScore: 20,
                maxScore: 28,
                category: 'Симптомы умеренной депрессии',
                description: 'Выявлены симптомы умеренной депрессии',
                longDescription:
                    'Ваш результат указывает на депрессивное расстройство умеренной выраженности. Это состояние может значительно влиять на вашу повседневную деятельность и качество жизни. Настоятельно рекомендуется обратиться к психологу или психотерапевту для получения профессиональной помощи. Эффективное лечение может включать психотерапию и, при необходимости, медикаментозную поддержку.',
            },
            {
                minScore: 29,
                maxScore: 63,
                category: 'Симптомы тяжелой депрессии',
                description: 'Обнаружены симптомы тяжелой депрессии',
                longDescription:
                    'Ваш результат указывает на тяжелое депрессивное расстройство. Это серьезное состояние, которое требует немедленного профессионального вмешательства. Настоятельно рекомендуется как можно скорее обратиться к психиатру или психотерапевту. Важно понимать, что депрессия — это излечимое заболевание, и профессиональная помощь может значительно улучшить ваше состояние. В случае мыслей о самоповреждении немедленно обратитесь за экстренной помощью.',
            },
        ],
    },
    {
        id: 'cancer-coping-single',
        title: 'Опросник совладания с онкологическим заболеванием (Вы сейчас не в отношениях)',
        description: 'The Cancer Coping Questionnaire (CCQ) - опросник для оценки способов совладания со стрессом при онкологическом заболевании',
        fullDescription: 'The Cancer Coping Questionnaire — авторы: S. Moorey, M. Frampton & S. Greer. Этот опросник создан специально для людей, проходящих путь лечения от онкологического заболевания. Он помогает понять, какие способы совладания с заболеванием вы используете сейчас — эмоциональные, когнитивные, поведенческие и межличностные. Зачем проходить тест? Чтобы лучше понять, что помогает вам справляться, а что может вызывать лишнее напряжение; чтобы психолог/специалист мог подобрать более точную поддержку; чтобы отследить изменения — например, до и после психологической помощи, группы или терапии.',
        instruction: 'В каждом утверждении отметьте, как часто за последние 7 дней вы использовали тот или иной способ справляться с переживаниями, связанными с болезнью. Нет правильных или неправильных ответов — есть только ваш личный опыт.',
        duration: '3-5 минут',
        imageUrl: '/images/character-coping-single.svg',
        higherIsBetter: true,
        questions: [
            {
                id: 'q1',
                text: 'Составляли ли вы определенные планы на будущее?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q2',
                text: 'Пытались ли вы дышать медленно и глубоко, чтобы совладать с тревогой?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q3',
                text: 'Отвлекались ли вы от беспокоивших вас мыслей?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q4',
                text: 'Напоминали ли вы себе, что причина боли может быть вызвана чем-то другим, кроме распространения рака?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q5',
                text: 'Составили ли вы список приоритетных задач на неделю, чтобы  иметь возможность сделать важные для вас вещи?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q6',
                text: 'Смогли ли вы отступить назад, чтобы со стороны оценить серьезность своего заболевания?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q7',
                text: 'Обнаружили ли вы в себе те сильные стороны, которые помогли бы вам совладать с онкологическим заболеванием?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q8',
                text: 'Справлялись ли вы со своей фрустрацией, переключаясь на другие предметы (например, такую физическую активность, как работа по дому или в саду)?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q9',
                text: 'Напоминали ли вы себе о других вещах, которые все еще присутствуют в вашей жизни, несмотря на рак?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q10',
                text: 'Организовывали ли вы свой день таким образом, чтобы прожить его с наибольшей пользой, несмотря на рак?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q11',
                text: 'Практиковали ли вы релаксацию?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q12',
                text: 'Реагировали ли вы на беспокоящие вас мысли?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q13',
                text: 'Планировали ли вы свой день таким образом, чтобы заниматься активностью, не связанной с онкологическим заболеванием?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q14',
                text: 'Старались ли вы думать о некоторых положительных сторонах своей жизни?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
        ],
        interpretations: [
            {
                minScore: 14,
                maxScore: 56,
                description: '',
                category: '',
                longDescription:
                    'Чем выше балл, тем более эффективно вы справляетесь с психологической нагрузкой, связанной с заболеванием.\n' +
                    'Баллы ближе к 56 означают, что за последнюю неделю вы активно использовали различные стратегии совладания, а это связано с лучшей адаптацией к поддержке и психологической терапии. Если результат ближе к 14, это может быть сигналом, что внутренние ресурсы сейчас ослаблены — и возможно, вам стоит получить дополнительную поддержку.'
            },
        ],
    },
    {
        id: 'cancer-coping-couple',
        title: 'Опросник совладания с онкологическим заболеванием (Вы сейчас состоите в отношениях)',
        description: 'The Cancer Coping Questionnaire (CCQ) - опросник для оценки способов совладания со стрессом при онкологическом заболевании',
        fullDescription: 'The Cancer Coping Questionnaire — авторы: S. Moorey, M. Frampton & S. Greer. Этот опросник создан специально для людей, проходящих путь лечения от онкологического заболевания. Он помогает понять, какие способы совладания с заболеванием вы используете сейчас — эмоциональные, когнитивные, поведенческие и межличностные. Зачем проходить тест? Чтобы лучше понять, что помогает вам справляться, а что может вызывать лишнее напряжение; чтобы психолог/специалист мог подобрать более точную поддержку; чтобы отследить изменения — например, до и после психологической помощи, группы или терапии.',
        instruction: 'В каждом утверждении отметьте, как часто за последние 7 дней вы использовали тот или иной способ справляться с переживаниями, связанными с болезнью. Нет правильных или неправильных ответов — есть только ваш личный опыт. Последняя часть опросника касается совместного совладания в паре.',
        duration: '5-8 минут',
        imageUrl: '/images/character-coping-couple.svg',
        higherIsBetter: true,
        questions: [
            {
                id: 'q1',
                text: 'Составляли ли вы определенные планы на будущее?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q2',
                text: 'Пытались ли вы дышать медленно и глубоко, чтобы совладать с тревогой?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q3',
                text: 'Отвлекались ли вы от беспокоивших вас мыслей?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q4',
                text: 'Напоминали ли вы себе, что причина боли может быть вызвана чем-то другим, кроме распространения рака?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q5',
                text: 'Составили ли вы список приоритетных задач на неделю, чтобы  иметь возможность сделать важные для вас вещи?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q6',
                text: 'Смогли ли вы отступить назад, чтобы со стороны оценить серьезность своего заболевания?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q7',
                text: 'Обнаружили ли вы в себе те сильные стороны, которые помогли бы вам совладать с онкологическим заболеванием?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q8',
                text: 'Справлялись ли вы со своей фрустрацией, переключаясь на другие предметы (например, такую физическую активность, как работа по дому или в саду)?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q9',
                text: 'Напоминали ли вы себе о других вещах, которые все еще присутствуют в вашей жизни, несмотря на рак?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q10',
                text: 'Организовывали ли вы свой день таким образом, чтобы прожить его с наибольшей пользой, несмотря на рак?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q11',
                text: 'Практиковали ли вы релаксацию?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q12',
                text: 'Реагировали ли вы на беспокоящие вас мысли?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q13',
                text: 'Планировали ли вы свой день таким образом, чтобы заниматься активностью, не связанной с онкологическим заболеванием?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q14',
                text: 'Старались ли вы думать о некоторых положительных сторонах своей жизни?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q15',
                text: 'Привлекали ли вы своего партнера к деятельности, помогавшей вам справляться с онкологическим заболеванием?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q16',
                text: 'Беседовали ли вы со своим партнером о влиянии рака на вашу жизнь?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q17',
                text: 'Спрашивали ли вы своего партнера, о чем он думает, вместо того, чтобы делать свои предположения об этом?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q18',
                text: 'Пробовали ли вы рассматривать свое онкологическое заболевание как вызов, который вам придется принять и противостоять ему вместе с вашим партнером?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q19',
                text: 'Обсуждали ли вы со своим партнером, какую поддержку он мог бы вам оказать?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q20',
                text: 'Беседовали ли вы со своим партнером о том, как бы вы могли организовать свою жизнь, чтобы снять с себя часть нагрузки (например, перераспределить домашние обязанности)?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
            {
                id: 'q21',
                text: 'Думали ли вы, каким образом ваше онкологическое заболевание сблизило вас с вашим партнером?',
                answers: [
                    { id: 'a1', text: 'Очень часто', score: 4 },
                    { id: 'a2', text: 'Часто', score: 3 },
                    { id: 'a3', text: 'Иногда', score: 2 },
                    { id: 'a4', text: 'Ни разу', score: 1 },
                ],
            },
        ],
        interpretations: [
            {
                minScore: 21,
                maxScore: 84,
                description: '',
                category: '',
                longDescription:
                    'Чем выше балл, тем более эффективно вы справляетесь с психологической нагрузкой, связанной с заболеванием.\n' +
                    'Баллы ближе к 84 означают, что за последнюю неделю вы активно использовали различные стратегии совладания, а это связано с лучшей адаптацией к поддержке и психологической терапии. Если результат ближе к 21, это может быть сигналом, что внутренние ресурсы сейчас ослаблены — и возможно, вам стоит получить дополнительную поддержку.'
            },
        ],
    },
];
